"use client";

import { Menu as MenuIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourCollectionOnDeck() {
  return null;
}